import React from 'react'
import Button from 'components/ui/button'
import Slider from 'components/ui/rc-slider'
import styles from './index.module.css'

type Props = {
  onChange: (...args: Array<any>) => any
  zoom: number
  min: number
  max: number
  step: number
}

const Zoom = ({
  onChange,
  zoom,
  min,
  max,
  step,
}: Props): React.ReactElement<'div'> => {
  return (
    <div className={styles.zoom}>
      <div>
        <Button
          appearance="icon"
          icon="zoom-out"
          onClick={() => {
            onChange(Math.max(min, zoom - step * 10))
          }}
        />
      </div>

      <div className={styles.zoomContainer}>
        <Slider
          step={step}
          min={min}
          max={max}
          value={zoom}
          onChange={value => {
            onChange(value)
          }}
          trackStyle={{
            background: '#5f63ee',
          }}
          railStyle={{
            background: '#EBECF0',
          }}
          handleStyle={{
            background: '#fff',
            boxShadow:
              '0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31)',
            width: '16px',
            height: '16px',
            borderRadius: '8px',
            border: 'none',
          }}
        />
      </div>
      <div>
        <Button
          appearance="icon"
          icon="zoom-in"
          onClick={() => {
            onChange(Math.min(max, zoom + step * 10))
          }}
        />
      </div>
    </div>
  )
}

export default Zoom
